import assign from 'object-assign';
import IFeatureState from '../../store/IFeatureState';
import * as ActionTypes from './ActionTypes';
import InitialState from './InitialState';

export default function se360UserReducer(
    state: any = InitialState.se360Users,
    action: { type: string; result: any }
) {
    let newState: IFeatureState;

    switch (action.type) {
        case ActionTypes.LIST_SE360_USERS_SUCCESS:
            newState = assign({}, state);
            newState.list = action.result;
            return newState;

        case ActionTypes.NEW_SE360_USER_SUCCESS:
            newState = assign({}, state);
            newState.new = action.result;
            return newState;

        case ActionTypes.CREATE_SE360_USER_SUCCESS:
            newState = assign({}, state);
            newState.list = [...state.list, assign({}, action.result)];
            return newState;

        case ActionTypes.EDIT_SE360_USER_SUCCESS:
            newState = assign({}, state);
            newState.list = [
                ...state.list.filter((x: any) => x.id !== action.result.user.id),
                assign({}, action.result.user)
            ];
            newState.edit = assign({}, action.result);
            return newState;

        case ActionTypes.UPDATE_SE360_USER_SUCCESS:
            newState = assign({}, state);
            newState.list = [
                ...state.list.filter((x: any) => x.id !== action.result.id),
                assign({}, action.result)
            ];
            return newState;

        case ActionTypes.DELETE_SE360_USER_SUCCESS:
            newState = assign({}, state);
            newState.list = [
                ...state.list.map((x: any) =>
                    x.id === action.result ? assign({}, x, { isRemoved: true }) : x
                )
            ];
            return newState;

        case ActionTypes.RESTORE_SE360_USER_SUCCESS:
            newState = assign({}, state);
            newState.list = [
                ...state.list.map((x: any) =>
                    x.id === action.result ? assign({}, x, { isRemoved: false }) : x
                )
            ];
            return newState;

        default:
            return state;
    }
}
